import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import Log from "./components/Log";
import LogLoader from "./components/LogLoader";

export default ({ selectedOrder }) => {
  const { data: logs } = useGetHook({
    queryKey: [`order-activity-${selectedOrder}`],
    url: `${APIS.ORDER_HISTORY}`,
    params: {
      object_id: selectedOrder,
      // exclude_field: "delivery_status",
    },
  });
  return (
    <div>
      <div className={tw`border-b-2 border-gray-200 pt-5`}>
        <h4 className={tw`text-lg font-bold`}>Acitivity Log</h4>
      </div>
      <div className={tw`max-h-[400px] overflow-y-auto`}>
        {logs
          ? logs.map((log: Record<string, any>) => (
              <Log key={log.id} {...(log as any)} />
            ))
          : Array.from({ length: 5 }).map((_, i) => <LogLoader key={i} />)}
      </div>
    </div>
  );
};
